const createBlob = byteArray => new Blob([byteArray], { type: 'application/pdf' });

export default createBlob;



// WEBPACK FOOTER //
// ./src/lib/helpers/PDFHelpers/createBlob.js